import { useMutation, useQuery } from "@tanstack/react-query";

import { useAxios, useApiResponseParser } from "../";

import type { IManufacturer } from "../../interfaces";

export default function useManufacturer() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();

    function useList() {
        return useQuery({
            queryKey: ["manufacturers"],
            queryFn: async () => {
                const response = await axiosPrivate.get("/v1/manufacture/list");
                return parseSuccessResponseData(response);
            },
        });
    }

    function useCreate() {
        return useMutation({
            mutationFn: async (data: {
                Name: string;
                ShortName: string;
                Headquarters?: string;
                Founded?: string;
                Industry?: string;
                Products?: string;
                Website?: string;
                Status?: string;
            }) => {
                const response = await axiosPrivate.post<IManufacturer>("/v1/manufacture/create", data);
                return parseSuccessResponseData(response);
            },
        });
    }

    function useUpdate() {
        return useMutation({
            mutationFn: async (data: {
                Id: string;
                Name?: string;
                ShortName?: string;
                Headquarters?: string;
                Founded?: string;
                Industry?: string;
                Products?: string;
                Website?: string;
                Status?: string;
            }) => {
                const response = await axiosPrivate.post<IManufacturer>("/v1/manufacture/update", data);
                return parseSuccessResponseData(response);
            },
        });
    }

    function useDelete() {
        return useMutation({
            mutationFn: async (id: string) => {
                const response = await axiosPrivate.delete(`/v1/manufacture/delete/${id}`);
                return parseSuccessResponseData(response);
            },
        });
    }

    return {
        useList,
        useCreate,
        useUpdate,
        useDelete,
    };
}
